import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../utils/api';
import './OrderConfirmationPage.css';

const OrderConfirmationPage = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get(`/orders/${id}`);
        setOrder(res.data.order);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    };
    fetch();
  }, [id]);

  if (loading) return <div className="loading-spinner" style={{paddingTop:'160px'}}><div className="spinner" /></div>;
  if (!order) return <div className="empty-state" style={{paddingTop:'160px'}}><h3>Order not found</h3></div>;

  return (
    <div className="confirmation-page">
      <div className="container">
        <div className="confirmation-card">
          <div className="confirmation-icon">✓</div>
          <h1>Order Placed Successfully!</h1>
          <p className="confirmation-sub">Thank you for shopping with Stonari Official</p>

          <div className="confirmation-details">
            <div className="detail-row">
              <span>Order ID</span>
              <strong>{order.orderId}</strong>
            </div>
            <div className="detail-row">
              <span>Total Amount</span>
              <strong>₹{order.totalAmount?.toFixed(0)}</strong>
            </div>
            <div className="detail-row">
              <span>Payment Status</span>
              <span className="status-badge paid">{order.paymentStatus}</span>
            </div>
            {order.delhiveryWaybill && (
              <div className="detail-row">
                <span>Tracking ID</span>
                <strong>{order.delhiveryWaybill}</strong>
              </div>
            )}
            <div className="detail-row">
              <span>Delivery To</span>
              <span>{order.shippingAddress?.city}, {order.shippingAddress?.state}</span>
            </div>
          </div>

          <div className="confirmation-items">
            <h3>Items Ordered</h3>
            {order.items?.map((item, i) => (
              <div key={i} className="conf-item">
                {item.image && <img src={item.image} alt={item.name} />}
                <div>
                  <p>{item.name}</p>
                  <p className="conf-item-qty">Qty: {item.quantity} × ₹{item.price}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="confirmation-actions">
            <Link to={`/track/${order.orderId}`} className="btn btn-primary">Track Your Order</Link>
            <Link to="/shop" className="btn btn-outline">Continue Shopping</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationPage;
